import React from 'react';
import { Link } from 'react-router-dom';

export default function Logo({ linkTo = '/', className = '', showTagline = false }) {
  return (
    <Link to={linkTo} className={`flex flex-col ${className}`}>
      <div className="flex items-center">
        <img 
          src="/logo.png" 
          alt="Daily UAE Jobs" 
          className="h-10 w-auto object-contain"
        />
        <span className="ml-2 text-xl font-bold text-gray-900">Daily UAE Jobs</span>
      </div>
      {showTagline && (
        <span className="text-xs text-gray-500 mt-0.5">From CV to Interview, Your Trusted Career Partner.</span>
      )}
    </Link>
  );
}
